import type {VersionInfo} from './app/utils.class';

export const compiledVersion: VersionInfo = {"buildNumber":"D. van der Steen B.V_acceptance_2026-11-03_23-0-44","buildId":"24862","environment":"dvds-acceptance","datetime":"2026-11-03T22:06:18.661Z","checkForUpdates":true}